/* Common Imports */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    padding: "2.5rem 8rem 4rem 8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0rem 1.5rem 0rem 1.5rem",
    },
      [theme.breakpoints.down("md")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
  },
  megaContainer: {
    width: "100%",
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 5rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 5rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 5rem 72rem",
    },
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      justifyContent: "center",
      gap: "2rem",
    },
    [theme.breakpoints.down("xs")]: {
      gap: "1rem",
    },
    // /* XXL breakpoint */
    [theme.breakpoints.up("xl")]: {
      gap: "4rem",
    },
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "1rem",
  },
  mobheading: {
      width: "100%",

    color: "#4A225B",
    fontWeight: 600,
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    fontSize: "1.25rem",
      lineHeight: "2rem",
    [theme.breakpoints.up("sm")]: {
    display: "none",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  heading: {
    width: "100%",
    margin: "0rem 0rem 1rem 0rem",
    color: "#4A225B",
    fontWeight: 600,
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    fontSize: "1.125rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("xs")]: {
      // fontSize: "1.25rem",
      // lineHeight: "2rem",
      // margin: "0rem 0rem 0rem 0rem",
      display: "none",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    width: "100%",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
    margin: "0rem 0rem 1rem 0rem",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "3.188rem",
      [theme.breakpoints.down("xs")]: {
      // fontSize: "1.25rem",
      //   lineHeight: "2rem",
        //   margin: "0rem 0rem 0rem 0rem",
          display: "none",
    },
  },
  bodyText: {
    margin: "0.5rem 0rem 0.5rem 0rem",
    width: "100%",
    color: "#000000",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  text: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    [theme.breakpoints.only("md")]: {
      width: "66%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  sectionTitle: {
    [theme.breakpoints.only("md")]: {
      width: "225px",
    },
    [theme.breakpoints.only("lg")]: {
      width: "440px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "500px",
    },
  },
  pulseBeaconContainerContainer: {
    position: "relative",
    zIndex: "1",
    height: "19rem",
    // width: "25%",
    [theme.breakpoints.only("md")]: {
      width: "225px",
    },
    [theme.breakpoints.only("lg")]: {
      width: "440px",
    },
    [theme.breakpoints.up("xl")]: {
      width: "500px",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    // Outer half box
    "&::before": {
      position: "absolute",
      content: "''",
      zIndex: 1,
      top: "2.125rem",
      right: "-0.955rem",
      width: "1rem",
      height: "1rem",
      transform: "translateX(0%) translateY(-50%)",
      border: "2px solid #5f2e73",
      transform: "scale(2)",
      [theme.breakpoints.only("md")]: {
        top: "1.25rem",
        right: "-0.4rem",
      },
      [theme.breakpoints.up("lg")]: {
        top: "2.15rem",
        right: "5.5rem",
      },
      [theme.breakpoints.up("xl")]: {
        top: "1.3651rem",
        right: "5.6rem",
        width: "0.7rem",
        height: "0.7rem",
        border: "1.5px solid #5f2e73",
        transform: "scale(3)",
      },
      /* XXL breakpoint */
      [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
        top: "2.45rem",
      },
    },
    // Line
    "&::after": {
      position: "absolute",
      content: "''",
      zIndex: 2,
      top: "2.5rem",
      right: "-5.8135rem",
      width: "5rem",
      height: "0.188rem",
      backgroundColor: "#5f2e73",
      transform: "translateX(0%) translateY(-50%)",
      [theme.breakpoints.only("md")]: {
        top: "1.75rem",
        right: "-4.813rem",
        width: "4rem",
      },
      [theme.breakpoints.only("lg")]: {
        top: "2.625rem",
        right: "0rem",
      },
      [theme.breakpoints.only("xl")]: {
        top: "1.625rem",
        right: "0rem",
      },
      /* XXL breakpoint */
      [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
        top: "2.625rem",
      },
    },
  },
  pulseBeaconContainer: {
    position: "relative",
    zIndex: "1",
    height: "100%",
    width: "100%",
    overflow: "hidden",
    [theme.breakpoints.only("lg")]: {
      height: "100%",
      width: "345px",
    },
    [theme.breakpoints.up("xl")]: {
      height: "25rem",
      width: "405px",
    },
  },
  pulseBeacon: {
    position: "absolute",
    top: "2.125rem",
    right: "-0.438rem",
    width: "1rem",
    height: "1rem",
    border: "2px solid #5f2e73",
    transform: "translateX(-50%) translateY(-50%)",
    animation: "$pulse 3s linear infinite",
    transform: "scale(2)",
    [theme.breakpoints.only("md")]: {
      top: "1.25rem",
    },
    [theme.breakpoints.only("lg")]: {
      top: "2.15rem",
    },
    [theme.breakpoints.up("xl")]: {
      top: "1.3651rem",
      right: "-0.338rem",
      width: "0.7rem",
      height: "0.7rem",
      border: "1.5px solid #5f2e73",
      transform: "scale(3)",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      top: "2.45rem",
    },
  },
  pulseBeaconContainerMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: "1",
    height: "15rem",
    width: "100%",
    overflow: "hidden",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.only("sm")]: {
      height: "23rem",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  pulseBeaconMobile: {
    position: "absolute",
    width: "0.988rem",
    height: "0.988rem",
    border: "2px solid #5f2e73",
    transform: "translateX(-50%) translateY(-50%)",
    animation: "$pulse 3s linear infinite",
    [theme.breakpoints.only("sm")]: {
      border: "2px solid #5f2e73",
      transform: "scale(1.5)",
    },
  },
  "@keyframes pulse": {
    "0%": {
      boxShadow:
        "0 0 15px 0px #FFFFFF,0 0 0 1px rgba(95, 46, 115, 1 ),0 0 15px 39px #FFFFFF,0 0 0 40px rgba(95, 46, 115, 0.75 ),0 0 15px 79px #FFFFFF,0 0 0 80px rgba(95, 46, 115, 0.5 )",
    },
    "100%": {
      boxShadow:
        "0 0 15px 39px #FFFFFF,0 0 0 40px rgba(95, 46, 115, 0.75 ),0 0 15px 79px #FFFFFF,0 0 0 80px rgba(95, 46, 115, 0.5 ),0 0 15px 129px #FFFFFF,0 0 0 130px rgba(95, 46, 115, 0 )",
    },
  },
}));
const AboutLocation = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.sectionTitle}>
            <div className={classes.pulseBeaconContainerContainer}>
              <div className={classes.pulseBeaconContainer}>
                <div className={classes.pulseBeacon} />
              </div>
            </div>
          </div>
           {/* <div className={classes.pulseBeaconContainerMobile}>
            <div className={classes.pulseBeaconMobile} />
          </div> */}
          <div className={classes.text}>
            <Typography variant="h1" component="h1" className={classes.mobheading}>
              Location : Off Sarjapur Road
            </Typography>
            <Typography variant="h1" component="h1" className={classes.heading}>
              Location
            </Typography>
            <Typography
              variant="h1"
              component="h1"
              className={classes.subHeading}
            >
              Off Sarjapur Road
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.bodyText}
            >
              Surround yourself with timeless quality in one of Sarjapur
              road&apos;s most coveted blue-chip addresses. This prestigious
              suburb caters to all lifestyles and is supported by outstanding
              recreational amenities, esteemed scholarly health facilities and
              unmatched connectivity.
            </Typography>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AboutLocation;
